<template>
    
    <div class="">
        <div>
            <b-card no-body style="width: 100%;">
                <b-tabs pills card>
                    <b-tab lazy title="Create New Transfer">
                        <RequestItems :showbacker="false"/>
                    </b-tab>
                    <b-tab lazy title="List Transfers" active>
                        <MyRequests :showbacker="false"/>
                    </b-tab>
                    <b-tab lazy title="Discrepancies" v-if="userDetails.userrole == 'admin'">
                        <MyRequests :showbacker="false" :viewdata="{discrepancies: true}"/>
                    </b-tab>
                    <b-tab lazy title="Create New Pullist" v-if="userDetails.userrole == 'admin'">
                        <GeneratePullist :showbacker="false" />
                    </b-tab>
                    <b-tab lazy title="List Pullists" v-if="userDetails.userrole == 'admin'">
                        <ListPullists :showbacker="false" />
                    </b-tab>
                    <!-- <b-tab lazy title="Pulled Items" v-if="userDetails.userrole == 'admin'">
                        <PulledItems :showbacker="false" />
                    </b-tab>
                    <b-tab lazy title="Shipped Transfers" v-if="userDetails.userrole == 'admin'">
                        <ShippedTransfers :showbacker="false" />
                    </b-tab> -->

                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
    import MyRequests from "@/components/MyRequests"
    import GeneratePullist from "@/components/GeneratePullist"
    import ListPullists from "@/components/ListPullists"
    import RequestItems from "@/components/RequestItems"
    import PulledItems from "@/components/PulledItems"
    import ShippedTransfers from "@/components/ShippedTransfers"

    export default {
        name: "TransferRequests",
        components: {MyRequests, GeneratePullist, ListPullists, RequestItems, PulledItems, ShippedTransfers},
        data: function(){
            return {
                userDetails: {properties: {}},
            }
        },
        methods: {
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
            }
        },

    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/TransferRequests.vue